module.exports = __webpack_public_path__ + "static/media/Frappé de Té Verde con Coco.6097286a.webp";